export default __webpack_public_path__ + "57e1e722b58ad46f04c0607de5d61b79.webp";